import { createContext } from 'react';

const catalogosContext = createContext();

export default catalogosContext;
